import { FC } from 'react';
import { Button } from '@mui/material';
import styled from '@emotion/styled';

import { colors } from '../../../styles/variables/colors';

import SearchIcon from '@mui/icons-material/Search';

const StyledInput = styled.input`
  height: 55px;
  width: 100%;
  padding-left: 12px;
  font-size: 14px;
  border-radius: 0;
  border-right: none;
  border: 0px;
  outline: none;
  font-family: 'IBM Plex Sans', sans-serif;
`;

const StyledSearchbarWrapper = styled.div`
  display: flex;

  button {
    height: 55px;
    width: 64px;
    border: none;
    border-radius: 0px;
    color: white;
    background-color: ${colors.red};

    &:hover {
      color: black;
      border: none;
      border-radius: 0px;
    }
  }
`;

interface ISearchBarProps {
  value: string;
  setValue: (value: string) => any;
  onSubmit: (...params: any) => any;
}

export const SearchBar: FC<ISearchBarProps> = ({
  value,
  setValue,
  onSubmit,
}) => {
  return (
    <StyledSearchbarWrapper>
      <StyledInput
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onSubmit();
          }
        }}
        placeholder="Zadejte klíčová slova"
      />
      <Button variant="outlined" onClick={onSubmit}>
        <SearchIcon />
      </Button>
    </StyledSearchbarWrapper>
  );
};
